import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api'
import {
  getAllMonsterUserSuccess,
  getAllMonsterUserFailed,
  GET_ALL_MONSTER_USER_START,
} from '../../actions/monster'

/**
 * get list monster user
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getListMonsterUserApi = (props) => {
  var uri = `/users/monster`
  return api.post(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetListMonsterUser(action) {
  try {
    const response = yield call(getListMonsterUserApi, action?.payload)
    yield put(getAllMonsterUserSuccess(response?.data))
    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response?.data)
    }
  } catch (error) {
    yield put(getAllMonsterUserFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get list monster user
 */
export default function* watchGetListMonsterUser() {
  yield takeLatest(GET_ALL_MONSTER_USER_START, doGetListMonsterUser)
}
